import { PartnerSearchResultType } from '../constants.esm.js';

var solutionItems = {
    'Technology products': [
        {
            title: 'IP services (ISV)',
            icon: 'Globe',
            navigateOptions: {
                type: 'marketplacePartnerSuggestion',
                query: {
                    value: 'IP Services (ISV)',
                    text: 'IP Services (ISV)',
                    type: PartnerSearchResultType.Service.toString()
                }
            }
        },
        {
            title: 'Custom solutions',
            icon: 'CustomizeToolbar',
            navigateOptions: {
                type: 'marketplacePartnerSuggestion',
                query: {
                    value: 'Custom solution',
                    text: 'Custom solution',
                    type: PartnerSearchResultType.Service.toString()
                }
            }
        },
        {
            title: 'Hardware',
            icon: 'PC1',
            navigateOptions: {
                type: 'marketplacePartnerSuggestion',
                query: {
                    value: 'Hardware',
                    text: 'Hardware',
                    type: PartnerSearchResultType.Service.toString()
                }
            }
        }
    ],
    Services: [
        {
            title: 'Consulting',
            icon: 'ChatInviteFriend',
            navigateOptions: {
                type: 'marketplacePartnerSuggestion',
                query: {
                    value: 'Consulting',
                    text: 'Consulting',
                    type: PartnerSearchResultType.Service.toString()
                }
            }
        },
        {
            title: 'System integration',
            icon: 'PlugConnected',
            navigateOptions: {
                type: 'marketplacePartnerSuggestion',
                query: {
                    value: 'Integration',
                    text: 'Integration',
                    type: PartnerSearchResultType.Service.toString()
                }
            }
        },
        {
            title: 'Cloud deployment or migration',
            icon: 'Deploy',
            navigateOptions: {
                type: 'marketplacePartnerSuggestion',
                query: {
                    value: 'Deployment or Migration',
                    text: 'Deployment or Migration',
                    type: PartnerSearchResultType.Service.toString()
                }
            }
        },
        {
            title: 'Project management',
            icon: 'TimelineProgress',
            navigateOptions: {
                type: 'marketplacePartnerSuggestion',
                query: {
                    value: 'ProjectManagement',
                    text: 'ProjectManagement',
                    type: PartnerSearchResultType.Service.toString()
                }
            }
        },
        {
            title: 'Training',
            icon: 'D365TalentLearn',
            navigateOptions: {
                type: 'marketplacePartnerSuggestion',
                query: {
                    value: 'Learning and Certification',
                    text: 'Learning and Certification',
                    type: PartnerSearchResultType.Service.toString()
                }
            }
        }
    ],
    Reseller: [
        {
            title: 'Licensing',
            icon: 'Certificate',
            navigateOptions: {
                type: 'marketplacePartnerSuggestion',
                query: {
                    value: 'Licensing',
                    text: 'Licensing',
                    type: PartnerSearchResultType.Service.toString()
                }
            }
        },
        {
            title: 'Managed services (MSP)',
            icon: 'CRMServices',
            navigateOptions: {
                type: 'marketplacePartnerSuggestion',
                query: {
                    value: 'Managed Services (MSP)',
                    text: 'Managed Services (MSP)',
                    type: PartnerSearchResultType.Service.toString()
                }
            }
        }
    ]
};

export { solutionItems };
